import {NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {SharedModule} from '@app/shared/shared.module';
import {EffectsModule} from '@ngrx/effects';
import {ContactComponent} from './components/contact/contact.component';
import {CookiePolicyComponent} from './components/cookie-policy/cookie-policy.component';
import {LegalNoticeComponent} from './components/legal-notice/legal-notice.component';
import {PrivacyPolicyComponent} from './components/privacy-policy/privacy-policy.component';
import {TermsAndConditionsComponent} from './components/terms-and-conditions/terms-and-conditions.component';
import {StaticPagesEffects} from './state/static-pages.effects';

@NgModule({
    imports: [SharedModule, ReactiveFormsModule, EffectsModule.forFeature([StaticPagesEffects]), TermsAndConditionsComponent,
        LegalNoticeComponent,
        PrivacyPolicyComponent,
        CookiePolicyComponent,
        ContactComponent],
})
export class StaticPagesModule {}
